/**
 * license-skus.ts — how the license views classify a SKU.
 *
 *   free or trial    viral, trial and seeded SKUs with huge allocations
 *                    (Power BI Free has 1,000,000). Left out of utilization
 *                    and idle-seat math. Mirrors `IsFreeLicense` in
 *                    UserInsightsService.cs; keep the two lists in step.
 *   storage add-on   a paid SKU whose units are tenant capacity, not seats.
 *                    Office 365 Extra File Storage counts gigabytes and is
 *                    never assigned to a user, so Compass's 4,240 GB read as
 *                    4,240 unassigned seats. Left out of seat math too.
 */

const FREE_LICENSE_PATTERNS = ['FREE', 'TRIAL', 'VIRAL', 'EXPLORATORY', 'SEEDED', 'DEVELOPERPACK', '_DEV', 'VIRTUALUSER', '_ADHOC']
const FREE_LICENSE_SKUS = new Set(['POWER_BI_STANDARD', 'WINDOWS_STORE', 'MCOPSTNC', 'MICROSOFT_BUSINESS_CENTER', 'STREAM'])

const STORAGE_ADD_ON_SKUS = new Set(['SHAREPOINTSTORAGE'])

export function isFreeOrTrialSku(skuPartNumber: string): boolean {
  const upper = skuPartNumber.toUpperCase()
  if (FREE_LICENSE_SKUS.has(upper)) return true
  return FREE_LICENSE_PATTERNS.some(p => upper.includes(p))
}

export function isStorageAddOnSku(skuPartNumber: string): boolean {
  return STORAGE_ADD_ON_SKUS.has(skuPartNumber.toUpperCase())
}

/** A paid SKU sold per seat: the only kind that belongs in seat and utilization math. */
export function isPaidSeatSku(skuPartNumber: string): boolean {
  return !isFreeOrTrialSku(skuPartNumber) && !isStorageAddOnSku(skuPartNumber)
}
